// Marquee (merchant Oct 31: text looked blurry). The CSS loop moves the text in fractional pixels, which browsers
// render soft. This moves the track in whole pixels with requestAnimationFrame at the same speed (half the track in 75 s),
// so the letters stay crisp. Pauses on hover (fine pointers). Reduced motion keeps the
// static CSS row; without JS the CSS animation stays as a fallback.
const reduce = matchMedia('(prefers-reduced-motion: reduce)');
const finePointer = matchMedia('(hover: hover) and (pointer: fine)');
document.querySelectorAll('.marquee-bar').forEach((bar) => {
  const track = bar.querySelector('.marquee-track');
  if (!track || reduce.matches) return;
  track.style.animation = 'none';
  const dir = document.documentElement.dir === 'rtl' ? 1 : -1;
  let half = track.scrollWidth / 2;
  let offset = 0;
  let last = performance.now();
  let paused = false;
  new ResizeObserver(() => { half = track.scrollWidth / 2; }).observe(track);
  bar.addEventListener('mouseenter', () => { if (finePointer.matches) paused = true; });
  bar.addEventListener('mouseleave', () => { paused = false; });
  const tick = (now) => {
    const dt = Math.min(now - last, 100);
    last = now;
    if (!paused && half > 0) {
      offset += (half / 75000) * dt;
      if (offset >= half) offset -= half;
      track.style.transform = `translateX(${dir * Math.round(offset)}px)`;
    }
    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
});
